import React, { useEffect } from 'react';
import { SeoBar } from '../components/SeoBar';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { HeroSection } from './edm-network-diamond-saw/HeroSection';
import { BreadcrumbSection } from './edm-network-diamond-saw/BreadcrumbSection';
import { DescriptionSection } from './edm-network-diamond-saw/DescriptionSection';
import { ProductsSection } from './edm-network-diamond-saw/ProductsSection';
export function EDMNetworkDiamondSawPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen w-full bg-white flex flex-col" data-id="element-2109">
      <SeoBar data-id="element-2110" />
      <Header data-id="element-2111" />
      <main className="flex-grow" data-id="element-2112">
        <div className="w-full bg-gray-50 pb-20 min-h-screen" data-id="element-2113">
          <HeroSection data-id="element-2114" />
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-2115">
            <BreadcrumbSection data-id="element-2116" />
            <DescriptionSection data-id="element-2117" />
            <ProductsSection data-id="element-2118" />
          </div>
        </div>
      </main>
      <Footer data-id="element-2119" />
    </div>;
}